import { useQuery } from "@tanstack/react-query";
import React from "react";
import Button from "../UI/Button";
import { API_IMPORT_ALL_KITE_EXCHANGE } from "../../utils/api/ApiConstant";
import { getAxios } from "../../Services/commonService";
import showToast from "../../utils/toastUtil";
import { useNavigate } from "react-router-dom";

const ImportExpiredContract = () => {
  const navigate = useNavigate();
  const onHandleView = () => {
    navigate("/import/expireInstrument");
  };

  return (
    <div className="card_bod">
      <h1 className="m-1">List of Expired contract</h1>
      <div className="btn_box">
        <Button className={"btn-primary "} onClick={() => onHandleView()}>
          View
        </Button>
        <Button className={"btn-danger"}>Cancel</Button>
      </div>
    </div>
  );
};

export default ImportExpiredContract;
